import { useHistory } from 'react-router'
import React, { useEffect, useRef, useState } from 'react'

import queryString from 'query-string'
import searchUrl from 'helpers/searchUrl'
import { SearchButton } from '../Header.style'
import detectOutside from 'helpers/detectOutside'
import SearchService from 'services/SearchService'
import SearchIcon from 'components/Icons/searchIcon'
import SearchAutoComplete from './SearchAutoComplete'

const SearchInput = ({ isMobile = false }) => {
  const [result, setResult] = useState({})
  const [search, setSearchValue] = useState('')
  const [focusActive, setFocusActive] = useState(false)

  const history = useHistory()

  const SearchRef = useRef(null)

  const { keyword: keywordParam } = queryString.parse(
    typeof window !== 'undefined' ? window.location.search : ''
  )

  useEffect(() => {
    const deb = setTimeout(() => {
      if (!search) {
        setResult({})
        return
      }
      SearchService.search(search).then(res => {
        setResult(res)
      })
    }, 300)

    return () => clearTimeout(deb)
  }, [search])

  useEffect(() => {
    if (keywordParam !== undefined) {
      setSearchValue(keywordParam)
    }
  }, [keywordParam])

  const handleKeyPress = e => {
    if (e.key === 'Enter' && search) {
      history.push(searchUrl(search))
      setFocusActive(false)
    }
  }

  const keywordChosen = k => {
    setSearchValue(k)
    history.push(searchUrl(k))
    setFocusActive(false)
  }

  const handleBlur = () => {
    setTimeout(() => setFocusActive(false), 150)
  }

  const executeSearch = () => {
    if (search) {
      history.push(searchUrl(search))
      setFocusActive(false)
    }
  }

  detectOutside(SearchRef, handleBlur)

  const inputClass = isMobile
    ? 'w-full pl-3 pr-[5px] pl-[27px] py-[11px] border border-slate-200 rounded-full text-[11px] bg-slate-50 transition-all duration-300 focus:bg-white text-slate-700'
    : 'w-full py-2 pl-3 pr-14 border-2 border-slate-200 rounded-full text-[15px] bg-slate-50 transition-all duration-300 focus:bg-white text-slate-700'

  return (
    <div className="relative flex-1" ref={SearchRef}>
      <input
        type="text"
        className={inputClass}
        placeholder="აქ იპოვი ყველაფერს..."
        value={search}
        onFocus={() => setFocusActive(true)}
        onKeyUp={handleKeyPress}
        onChange={e => setSearchValue(e.target.value)}
        name="search"
      />
      <SearchButton onClick={executeSearch}>
        <SearchIcon
          color={isMobile ? '#FF4057' : 'white'}
          width={isMobile ? 16 : 18}
          height={isMobile ? 16 : 18}
        />
      </SearchButton>

      {focusActive && Object.keys(result).length ? (
        <SearchAutoComplete
          keyword={search}
          onClick={handleBlur}
          onKeywordChoose={keywordChosen}
          onSeeAll={() => history.push(searchUrl(search))}
          result={result}
        />
      ) : null}
    </div>
  )
}

export default SearchInput
